import React from "react";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Divider } from "@mui/material";

// Styled Grid Container
const StyledGridContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

// Styled Grid Item
const StyledGridItem = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "1rem",
}));

// Styled Icon Container
const StyledIconContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "1rem",
  width: "100%",
}));

// Styled Icon Image
const StyledIcon = styled("img")(({ theme }) => ({
  width: "5%",
  marginRight: "10px",
  verticalAlign: "middle",
  [theme.breakpoints.down("sm")]: {
    width: "10%",
  },
}));

// Styled Title
const StyledTitle = styled(Typography)(({ theme }) => ({
  textAlign: "left",
  letterSpacing: "0.66px",
  color: "#223140",
  fontFamily: "AvenirLTStd-Roman",
  fontSize: 32,
  [theme.breakpoints.down("sm")]: {
    fontSize: 25,
  },
  [theme.breakpoints.between("sm", "md")]: {
    fontSize: 25,
  },
}));

// Styled Description
const StyledDescription = styled(Typography)(({ theme }) => ({
  paddingLeft: "2rem",
  lineHeight: 2,
  width: "100%",
  textAlign: "left",
}));

// Styled Content Image
const StyledImage = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: "300px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "15px",
}));

// Styled Divider
const StyledDivider = styled(Divider)(({ theme }) => ({
  borderColor: "red",
  marginTop: "4%",
  width: "50%",
  marginLeft: "2rem",
}));

function EtlPros() {
  const data = [
    {
      row: 1,
      left: {
        icon: "/images/product-icons/ic_data-pilot.png",
        title: "Seamless Data Access",
        description:
          "Ability for online and offline data entry on various devices, flight crews can access essential journey log information anytime, ensuring they have the necessary data to make informed decisions.",
      },
      right: "/images/product-images/img_data-pilot.gif",
    },
    {
      row: 2,
      left: "/images/product-images/img_digitalmel-tech.gif",
      right: {
        icon: "/images/product-icons/DigitalMEL-Tech.png",
        title: "Digital MEL",
        description:
          "Operators can upload aircraft MELs to the Command system and populate it in the application so that crews can leverage digital Minimum Equipment Lists (MELs) for easy, error-free defect recording online, offline, and in-flight. Minimize delays and human errors with a consistent data input method.",
      },
    },
    {
      row: 3,
      left: {
        icon: "/images/product-icons/ic_reporting-pilot.png",
        title: "Customised Reporting",
        description:
          "Generate tailor-made digital reports with Pilot’s instant data access and PDF export. Export data in a standardised format to leave a record on the ground and for a seamless flow of information.",
      },
      right: "/images/product-images/img_reporting-pilot.gif",
    },
  ];

  return (
    <StyledGridContainer container spacing={2}>
      {data.map((item) => (
        <Grid key={item.row} container size={{ xs: 12, md: 12 }} sx={{ padding: "1rem", marginTop: "2%" }}>
          <StyledGridItem size={{ xs: 12, md: 6 }}>
            {typeof item.left === "object" ? (
              <div>
                <StyledIconContainer>
                  <StyledIcon src={item.left.icon} alt={item.left.title} />
                  <StyledTitle variant="h6">{item.left.title}</StyledTitle>
                </StyledIconContainer>
                <StyledDescription variant="body1">
                  {item.left.description}
                </StyledDescription>
                <StyledDivider />
              </div>
            ) : (
              <StyledImage src={item.left} alt="Left Image" />
            )}
          </StyledGridItem>
          <StyledGridItem size={{ xs: 12, md: 6 }}>
            {typeof item.right === "object" ? (
              <div>
                <StyledIconContainer>
                  <StyledIcon src={item.right.icon} alt={item.right.title} />
                  <StyledTitle variant="h6">{item.right.title}</StyledTitle>
                </StyledIconContainer>
                <StyledDescription variant="body1">
                  {item.right.description}
                </StyledDescription>
                <StyledDivider />
              </div>
            ) : (
              <StyledImage src={item.right} alt="Right Image" />
            )}
          </StyledGridItem>
        </Grid>
      ))}
    </StyledGridContainer>
  );
}

export default EtlPros;
